import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import TransferActivityPage, { getDefaultPageUI } from "components/pages/TransferActivityPage";
import TransferHistoryPage from "components/pages/TransferActivityPage/components/TransferHistoryPage";

/**
 * @name CaptureTransfersTransfersHistory
 * @returns {React.Component}
 * @description The capture component the transfer activity page
 * with the transfer history showing.
 * This capture is used in the following capture groups:
 * "Transfers - Recurring" (abi22), "Transfers" (mabi23).
 */
export default function CaptureTransfersTransfersHistory(props) {
    // Initalize a new instance of BCMSStateManagerCRUD using the default page ui
    // updating the content and transferHistory properties
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        // Sets the component to be used for the content
        .update([ "content" ], TransferHistoryPage)
        // Sets the tab to be selected
        .update([ "transferHistory", "isActive" ], true)
        .submit();

    // Return the TransferActivityPage passing the ui variable
    return <TransferActivityPage ui={ ui } />
}